import React, { useState, useEffect, ChangeEvent } from 'react';
import { Row, Col, Alert } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { DetailItem } from '../../../../features/details';
import { updateProduct, addProduct } from '../../../../services/api/product';
import { getDescriptions, getSiteType } from '../../../../services/api/site'
import { ApiError, Product } from '../../../../services/openapi';
import { useKeycloak } from '@react-keycloak/web'
import { PropertyInfo } from '../../../../services/openapi/models/PropertyInfo';
import { Link, useNavigate } from "react-router-dom";
import { NotImplementedWarningModal } from '../../../../components/NotImplementedWarningModal';
import { setPendingSelectedId } from '../../../../hooks/pendingSelection';
import { useTranslation } from 'react-i18next';

const ProductDetails = () => {
    const [product, setProduct] = useState<any>();
    const [showInputEle, setShowInputEle] = useState<boolean>(false);
    const [showModal, setShowModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string[]>([]);
    const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
    const [siteDescriptions, setSiteDescriptions] = useState<Record<string,string>>({});

    const { keycloak, initialized } = useKeycloak();
    const token = keycloak.token || '';

   const navigate = useNavigate();
   const { t } = useTranslation();
    
    const navigateBack = () => {
        navigate('/dashboard/lists/products');
    };


    const setProductData = (data: Product) => {
        localStorage.setItem('Product', JSON.stringify(data));
    }

    const toggleInputElements = (show: boolean) => {
        setShowInputEle(show);
        if (show) {
            document.querySelector('.errorMsg')?.classList.add("d-none");
            errorMsg.length = 0;
        }
    }
    function pushErrorMessages(errors: any) {
        Object.entries<Record<string, any>>(errors).forEach((k: [string, Record<string, any>]) => {
            k[1].forEach((msg: string) => {
                errorMsg.push(msg);
            });
        });
    }

    const showErrorMessages = (errors: string[] | void) => {
        if (errors) {
            errors.forEach((msg: string) => { errorMsg.push(msg); })
        }

        document.querySelector('.errorMsg')?.classList.remove("d-none");
        setIsRefreshing(false);
    }

    const handleProductChange = async (e: ChangeEvent<HTMLInputElement>, fieldKey: keyof typeof product) => {
        const newValue = e.target.value;

        setProduct(prev => ({
            ...prev,
            [fieldKey]: newValue,
            vmcIds: fieldKey === 'siteId' ? null : prev.vmcIds,
        }));

        if (fieldKey === 'siteId' && newValue) {
            try {
            const siteType = await getSiteType(token, newValue);
            setProduct(prev => ({
                ...prev,
                siteType,
            }));
            } catch (error) {
                try {
                    document.querySelector('.errorMsg')?.classList.remove('d-none');
                    pushErrorMessages(JSON.parse((error as ApiError).body)['errors']);
                    showErrorMessages();
                } catch (ex) {
                    console.log(ex);
                    showErrorMessages(['Error handling response']);
                }
            }
        }
    };

    useEffect(() => {
        if (product == null) {
            getDescriptions(token).then(map => {
                setSiteDescriptions(map);
            }).catch((ex: ApiError) => {
                console.log(ex);
                showErrorMessages(["Error handling response"]);
            });

            const json = localStorage.getItem('Product') ?? "";
            const item = JSON.parse(json);

            setProduct(item);

            errorMsg.length = 0;        
            document.querySelector('.errorMsg')?.classList.add("d-none");

            if (item["id"] === 0) {
                toggleInputElements(true);
            }
        }
        else if (!product.siteType) {
            getSiteType(token, product.siteId).then((siteType) =>
                setProduct(prev => ({
                                ...prev,
                                siteType,
                            }))
            );            
        }
    }, [isRefreshing, product]);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();

        document.querySelector('.errorMsg')?.classList.add("d-none");
        errorMsg.length = 0;

        if (e.currentTarget.checkValidity()) {
            let p: Product = product;

            //TODO
            const actualKeyCharging =  Object.entries(product["propertyNames"]['unit_Charging'].enumMap).find(([_, val]) => val === p.unit_Charging)?.[0];
            const actualKeyControllino = Object.entries(product["propertyNames"]['unit_Controllino'].enumMap).find(([_, val]) => val === p.unit_Controllino)?.[0];
            if (actualKeyCharging) {
                p.unit_Charging = actualKeyCharging;  // Send key to backend
            }
            if (actualKeyControllino) {
                p.unit_Controllino = actualKeyControllino;
            }

            setProductData(p);
            setIsRefreshing(true);

            if (p.id === 0) {
                p.limit_Charging = p.limit_Charging.toString();
                p.limit_Controllino = p.limit_Controllino.toString();
                p.chargeAmount = p.chargeAmount.toString();
                p.pricePerUnit = p.pricePerUnit.toString();
                addProduct(token, p).then((id) => {
                    if (id) {
                        let np: Product = { ...(product as Product) } as Product;
                        np.id = id;
                        setProduct(np);
                        setProductData(np);
                        setIsRefreshing(false);
                        navigateBack();
                    }
                }).catch((error: ApiError) => {
                    try {
                        document.querySelector('.errorMsg')?.classList.remove("d-none");
                        if (error.body) {
                            pushErrorMessages(JSON.parse(error.body)["errors"]);
                            showErrorMessages();
                        }
                        else {
                            showErrorMessages([error.message]);
                        }                        
                    } catch (ex) {
                        console.log(ex);
                        showErrorMessages(["Error handling response"]);
                    }
                });
            }
            else {
                updateProduct(token, p.id ?? 0, p).then(() => {setIsRefreshing(false); navigateBack()}).catch((error: ApiError) => {
                    try {
                        document.querySelector('.errorMsg')?.classList.remove("d-none");
                        pushErrorMessages(JSON.parse(error.body)["errors"]);
                        showErrorMessages();
                    } catch (ex) {
                        console.log(ex);
                        showErrorMessages(["Error handling response"]);
                    }
                });
            }

            toggleInputElements(!showInputEle);
        }
    }

    return (
        <>
            <div className="">
                <NotImplementedWarningModal
                    showModal={showModal}
                    handleClose={() => {
                        setShowModal(false);
                    }}
                />
            </div>
            <Row className="">
                <Col className="">
                    <Card className="rounded">
                        <Card.Body className="">
                            <form onSubmit={e => handleSubmit(e)}>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="d-none d-md-block">
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" className="">
                                        <h4 className="mb-2 qvend-title">{product?.id ? t("productdetails") : t("productToevoegen")}</h4>
                                    </Col>
                                </Row>
                                <Row className="">
                                    <Col sm="12" xs="12" className="mt-2">
                                        <div className="table-responsive-lg" style={{ overflowX: 'hidden' }}>
                                            <div>
                                                {product && Object.entries<PropertyInfo>(product)
                                                    .filter(([key, value]) => {
                                                        const propInfo = product["propertyNames"][key];
                                                        if (!propInfo) return false;
                                                        if (propInfo.editType === '' && value === null  || propInfo.editType === 'hidden') return false;
                                                        if (propInfo.hideOnNull && (value === null || value === undefined)) return false;
                                                        
                                                        // Check conditionToShowFieldName with conditionToShowValue
                                                        if (propInfo.conditionToShowFieldName && propInfo.conditionToShowValue) {
                                                            const actualValue = product[propInfo.conditionToShowFieldName];
                                                            if (actualValue !== propInfo.conditionToShowValue) return false;
                                                        }
                                                        
                                                        return true;
                                                    })
                                                    .sort((a, b) => 
                                                        product["propertyNames"][a[0]].sortOrderLevel - 
                                                        product["propertyNames"][b[0]].sortOrderLevel
                                                    )
                                                    .map(([key, value], index) => {
                                                        const propInfo = product["propertyNames"][key];
                                                        
                                                        return (
                                                            <DetailItem 
                                                                key={propInfo.sortOrderLevel} 
                                                                propertyName={propInfo.name} 
                                                                value={value ?? ""}  
                                                                defaultValue={value ?? ""} 
                                                                rowColor={index % 2 ? "#cfd5ea" : "#e9ebf5"}
                                                                editType={propInfo.editType} 
                                                                pattern={propInfo.valPattern} 
                                                                hideOnNull={propInfo.hideOnNull}
                                                                handleDoubleClick={() => toggleInputElements(true)}
                                                                handleChange={(e: ChangeEvent<HTMLInputElement>) => handleProductChange(e, key)}
                                                                showInputEle={showInputEle} 
                                                                possibilities={key == "siteId" && propInfo.predefinedValues.length > 1? propInfo.predefinedValues : null} 
                                                                possibilityDescriptions={key == "siteId" && propInfo.predefinedValues.length > 1 ? siteDescriptions : null} 
                                                                enumMap={propInfo.enumMap} 
                                                                conditionToShowReferenceValue={product[propInfo.conditionToShowFieldName]} 
                                                                conditionToShowFieldName={propInfo.conditionToShowFieldName} 
                                                                conditionToShowValue={propInfo.conditionToShowValue}
                                                            />
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="d-none errorMsg">
                                    <Col>
                                        {
                                            errorMsg.map((item, index) => {
                                                return <Alert key={index} variant="warning" className="alert" role="alert">
                                                    <span>{item}</span>
                                                </Alert>;
                                            })
                                        }
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: "12px" }}>
                                    <Col>                                        
                                        {/*<button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={() => setShowModal(true)}>{t("button.photo")}</button>*/}
                                    </Col>
                                    <Col className="text-end">                                        
                                    </Col>
                                </Row>                                
                                <Row style={{ paddingTop: "3px" }}>
                                    <Col>
                                        <Link to="/dashboard/lists/products" onClick={() => setPendingSelectedId("products", product?.id)}>
                                            <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px', backgroundColor: "red" }} onClick={() => { }}>{showInputEle ? t("button.cancel") : t("button.back")}</button>
                                        </Link>
                                    </Col>
                                    <Col className="text-end">
                                        {showInputEle ?
                                            (<button type="submit" className="btn btn-fixed-width" style={{ fontSize: '11px' }}>{product && product.id > 0 ? t("button.save") : t("button.add")}</button>) :
                                            (<button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={(e) => { e.preventDefault(); toggleInputElements(true); }}>{t("button.edit")}</button>)
                                        }
                                    </Col>
                                </Row>
                            </form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default ProductDetails;